import { SupermarketService } from "@/clients/services/SupermarketService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetSupermarketPreferences = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.SUPERMARKET_PREFERENCES],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await SupermarketService.getSupermarketPreferencesApiV1SupermarketsPreferencesGet(
          user.id,
        );
      return data;
    },
  });
  return {
    preferences: data,
    isLoading,
    isError,
    error,
  };
};
